<app-complex-modal-template
    [canConfirm]="canConfirm()"
    [isSearchbarActive]="isSearchbarActive()"
    [messageInformation]="messageInformation()"
    [stepNumber]="this.currentSteps().length"
    [title]="currentTitle()"
    [(currentStep)]="currentStep"
    [(searchInput)]="searchInput"
    (currentStepChange)="changeCurrentStep()"
    (onClickEvent)="closeModal($event)">
    <ng-container>
        @if (isAddLayerLoading()) {
            <app-progress-bar
                [itemsLoaded]="addLayerService.layerCreatedCount()"
                [total]="addLayerService.layerToCreateCount()" />

            @if (displayErrorCreation()) {
                <p class="text-error">
                    {{ 'errorWhileCreatingLayers' | transloco }}
                </p>
            }
        } @else {
            @if (
                addLayerService.serviceCatalogResolutionErrors().length &&
                currentStepEnum() !== AddLayerStepEnum.SELECT_LAYER_INFO_STEP
            ) {
                <div class="mb-4 rounded-lg border border-error p-3">
                    <p class="text-error font-medium">
                        {{ 'fluxResolutionErrorsTitle' | transloco }}
                    </p>
                    @for (
                        error of addLayerService.serviceCatalogResolutionErrors();
                        track error.layerName + error.sourceURL
                    ) {
                        <div class="mt-2 text-sm">
                            <p class="text-error">{{ error.layerName }}: {{ error.errorMessage | transloco }}</p>
                            <p class="break-all text-custom-dark-grey">
                                {{ error.sourceURL }}
                            </p>
                        </div>
                    }
                </div>
            }
            @switch (currentStepEnum()) {
                @case (AddLayerStepEnum.SELECT_LAYER_TYPE_STEP) {
                    <span class="custom-text">{{ 'layerType' | transloco }}</span>
                    <div class="w-4/5 pb-6">
                        <app-select
                            [defaultValue]="layerTypeDefaultValue()"
                            [options]="typeOption"
                            [placeholder]="'selectLayerType'"
                            (optionSelected)="selectType($event)" />
                    </div>
                }
                @case (AddLayerStepEnum.SELECT_DEPOSIT_STEP) {
                    <app-select-reference-deposit-step />
                }
                @case (AddLayerStepEnum.SELECT_DATA_STEP) {
                    @switch (selectedLayerType()) {
                        @case (AddLayerSelectionType.TABLE) {
                            <app-select-deposit-step />
                        }
                        @case (AddLayerSelectionType.INTERSTANDARD) {
                            <app-select-interstandard-step />
                        }
                        @case (AddLayerSelectionType.FLUX) {
                            <app-select-flux-step [searchInput]="searchInput()" />
                        }
                        @case (AddLayerSelectionType.REFERENCE_DATA) {
                            <app-select-reference-data-step [searchInput]="searchInput()" />
                        }
                    }
                }
                @case (AddLayerStepEnum.SELECT_LAYER_NAME_STEP) {
                    <app-select-layer-step
                        [allTablesByDeposit]="allTablesByDeposit()"
                        [isLayerPreset]="isLayerPreset()"
                        [isTableLoading]="isTableLoading()"
                        [selectedLayerType]="selectedLayerType()"
                        (handlePreselection)="handlePreselection()" />
                }
                @case (AddLayerStepEnum.SELECT_LAYER_INFO_STEP) {
                    <app-add-layer-list-info
                        [hasFieldInterventions]="hasFieldInterventions()"
                        [layerType]="selectedLayerType()!" />
                }
            }
        }
    </ng-container>
</app-complex-modal-template>
